import React, {useState} from "react";
import mtaLogo from "../assets/images/mta-logo.png";
import rebuildIcon from "../assets/images/Footer/rebuild_icon.svg";
import improveIcon from "../assets/images/Footer/improve_icon.svg";
import expandIcon from "../assets/images/Footer/expand_icon.svg";
import nextStepsIcon from "../assets/images/Footer/nextstops_icon.svg";
import backToTop from "../assets/images/back-to-top.png";

const homePageText = (<><h2>Our plan</h2><p className="p2">We have developed a three-part plan for the next 20 years to achieve the transit network New Yorkers deserve. It is based on three fundamental ideas: rebuild the foundation of the system to ensure its survival, improve our network to meet 21st century needs, and expand to support future growth.</p></>);

const Footer = ({isHome: initialIsHome, id, class: footerClass, text: footerText, nextStepsCap}) => {
    const currentPath = window.location.pathname;
    const [isHome] = useState(initialIsHome);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
            duration: 1800,
        });
    };

    footerText = footerText || homePageText; // Use the provided text or default to homePageText
    if (isHome === true) {

        return (
            <footer id={id} className={footerClass}>
                <div className="row">
                    <div className="col-md-12">
                        {footerText}

                        <nav className="subpage-menu">
                            <ul>
                                <li>
                                    <a href="/rebuild">
                                        <img src={rebuildIcon} alt="" aria-hidden="true" />
                                        <h3>Rebuild</h3>
                                        <p>Our future depends on a commitment to rebuild our aging system.</p>
                                    </a>
                                </li>
                                <li>
                                    <a href="/improve">
                                        <img src={improveIcon} alt="" aria-hidden="true" />
                                        <h3>Improve</h3>
                                        <p>Our mandate has grown to meet changing needs.</p>
                                    </a>
                                </li>
                                <li>
                                    <a href="/expand">
                                        <img src={expandIcon} alt="" aria-hidden="true" />
                                        <h3>Expand</h3>
                                        <p>Once our foundation is secure, we can continue to pursue smart expansions to support our changing region.</p>
                                    </a>
                                </li>
                                <li>
                                    <a href="/next-steps">
                                        <img src={nextStepsIcon} alt="" aria-hidden="true" />
                                        <h3>Next Steps</h3>
                                        <p>The 20-Year Needs Assessment underscores the urgency of investing in our region's transportation network.</p>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        {nextStepsCap}
                    </div>
                </div>
                <div className="mta-footer">
                    <img src={mtaLogo} alt="Metropolitan Transportation Authority" />
                    <p>The MTA conducted a 20-Year-Needs Assessment that evaluates the condition of our transit network and the needs of our riders over the next two decades. It comes at a critical moment for the future of the region's mobility.</p>

                    <a href = {currentPath} onClick={scrollToTop} style={{ cursor: 'pointer' }} rel="noopener noreferrer">
                        <span className="ada-element">Back to top</span>
                        <img src={backToTop} alt="" aria-hidden="true" />
                    </a>
                </div>
            </footer>
        );
    }
    else {
        return (
            <footer>
                <div className="mta-footer">
                    <img src={mtaLogo} alt="Metropolitan Transportation Authority" />
                    <p>The MTA conducted a 20-Year-Needs Assessment that evaluates the condition of our transit network and the needs of our riders over the next two decades. It comes at a critical moment for the future of the region's mobility.</p>

                    <a href = {currentPath} onClick={() => scrollToTop} style={{ cursor: 'pointer' }} rel="noopener noreferrer">
                        <span className="ada-element">Back to top</span>
                        <img src={backToTop} alt="" aria-hidden="true" />
                    </a>
                </div>
            </footer>
        );
    }
};


export default Footer;